import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brandName, outcomes } from '../data/copy';
export function FinalCtaSection() {
  const negatives = outcomes.filter(outcome => !outcome.positive);
  const positives = outcomes.filter(outcome => outcome.positive);
  return <section className="defer-paint w-full bg-zinc-900 py-12 sm:py-16" aria-labelledby="final-cta-heading" data-id="element-59" data-mp="3vrkxpiy7qddw">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-60" data-mp="2y66oyezbxq4w">
        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-61" data-mp="333p08c0tkhg2">La prossima settimana</p>
        <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-serif text-[2rem] font-bold leading-[1.08] text-stone-100 sm:text-[2.6rem]" data-id="element-62" data-mp="3820b8q2uoxzv">
          Puoi continuare a preparare ogni allenamento partendo da zero…
        </h2>

        <div className="mx-auto mt-10 grid max-w-3xl items-stretch gap-4 text-left sm:grid-cols-[1fr_auto_1fr]" data-id="element-63" data-mp="2fc9vydphfq26">
          <div className="rounded-3xl border border-zinc-800 bg-zinc-950 p-6" data-id="element-64" data-mp="2dc0davzoth2i">
            <h3 className="font-serif text-lg font-bold text-stone-100" data-id="element-65" data-mp="2de30l89ggw3j">
              Continua a improvvisare
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-66" data-mp="23lxbc6al8ss1">
              {negatives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed text-stone-400" data-id="element-67" data-mp="23k42qlgezyhe">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" strokeWidth={2.6} aria-hidden="true" data-id="element-68" data-mp="1ul8t0ze5w69c" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
          <p className="self-center text-center font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-stone-400" data-id="element-69" data-mp="1kn2t2nbx1a74">
            Oppure
          </p>
          <div className="rounded-3xl border border-yellow-500/40 bg-yellow-500/[0.07] p-6" data-id="element-70" data-mp="1fq2ropq0gvmc">
            <h3 className="font-serif text-lg font-bold text-yellow-500" data-id="element-71" data-mp="3f0kkwmjcst7y">
              Prendi {brandName}
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-72" data-mp="3a0g0ilfbrecg">
              {positives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-[0.88rem] font-semibold leading-relaxed text-stone-100" data-id="element-73" data-mp="18bsd9osxaezy">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-yellow-500" strokeWidth={2.6} aria-hidden="true" data-id="element-74" data-mp="yffliwgxub7u" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-9 max-w-prose font-sans text-base leading-relaxed text-stone-400" data-id="element-75" data-mp="1r3bbzjfwz6w6">
          Non hai bisogno di ricordare centinaia di esercizi.{' '}
          <span className="text-stone-100" data-id="element-76" data-mp="1i2wp4fnaxjqk">
            Hai bisogno di un sistema che ti aiuti a scegliere, mostrare,
            correggere e progredire.
          </span>
        </p>

        <CtaButton size="large" className="mt-8" data-id="element-77" data-mp="1m6cmje773o4b">
          Ottieni {brandName} ora
        </CtaButton>
        <p className="mt-4 font-sans text-[11px] text-stone-400" data-id="element-78" data-mp="6q403clwb9e7">
          Pagamento sicuro · accesso immediato · garanzia di 7 giorni
        </p>
      </div>
    </section>;
}